var translation = {
	Navatar: {
		header: "Hồ sơ AWS",
		subheader: "Hồ sơ của bạn giúp cải thiện tương tác của bạn với các trải nghiệm AWS được chọn.",
		profileButtonText: "Xem hồ sơ",
		logOutText: "Đăng xuất",
		logInText: "Đăng nhập",
		createProfileText: "Tạo hồ sơ",
		federateLoginModalTitle: "Sử dụng Midway để truy cập Hồ sơ AWS của bạn",
		federateLoginModalFirstDescription: "Với tư cách là nhân viên của Amazon, chúng tôi khuyên bạn nên sử dụng Midway để truy cập Hồ sơ AWS của bạn. Phương pháp được khuyến nghị vì lý do bảo mật này cung cấp khả năng tích hợp liền mạch với các hệ thống nội bộ.",
		federateLoginModalSecondDescription: "Bạn thấy thông báo này vì bạn đã đăng nhập bằng địa chỉ email Amazon qua ID người xây dựng trên AWS. Lời nhắc này sẽ xuất hiện mỗi khi bạn đăng nhập cho đến khi bạn chuyển sang Midway hoặc chọn tiếp tục việc đăng nhập hiện tại của mình.",
		federateLoginModalPrimaryButton: "Đăng nhập với Midway",
		federateLoginModalSecondaryButton: "Tiếp tục với ID người xây dựng trên AWS"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
